export const enableScroll = () => {
    const scrollY = document.body.style.top;
    const $page = document.getElementById('page');
  
    if ($page) {
        $page.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
    }
}
  
export const disableScroll = () => {
    const $page = document.getElementById('page');

    if ($page) {
        document.body.style.top = `-${window.scrollY}px`;
        $page.style.position = 'fixed';
    }
}
